import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {

  clientListArr: any = [
    {
      id: 1,
      category: 'Cotton',
      details: [
        {
          id: 101,
          image: 'assets/img/clients/client01.jpg'
        },
        {
          id: 102,
          image: 'assets/img/clients/client02.jpg'
        },
        {
          id: 103,
          image: 'assets/img/clients/client03.jpg'
        },
        {
          id: 104,
          image: 'assets/img/clients/client04.jpg'
        },
        {
          id: 105,
          image: 'assets/img/clients/client05.jpg'
        },
        {
          id: 106,
          image: 'assets/img/clients/client06.jpg'
        },
        {
          id: 107,
          image: 'assets/img/clients/client07.jpg'
        },
        {
          id: 108,
          image: 'assets/img/clients/client08.jpg'
        },
        {
          id: 109,
          image: 'assets/img/clients/client09.jpg'
        },
        {
          id: 110,
          image: 'assets/img/clients/client10.jpg'
        },
        {
          id: 111,
          image: 'assets/img/clients/client11.jpg'
        },
        {
          id: 112,
          image: 'assets/img/clients/client12.jpg'
        },
        {
          id: 113,
          image: 'assets/img/clients/client13.jpg'
        },
        {
          id: 114,
          image: 'assets/img/clients/client14.jpg'
        },
        {
          id: 115,
          image: 'assets/img/clients/client15.jpg'
        },
        {
          id: 116,
          image: 'assets/img/clients/client16.jpg'
        },
        {
          id: 117,
          image: 'assets/img/clients/client17.jpg'
        },
        {
          id: 118,
          image: 'assets/img/clients/client18.jpg'
        },
        {
          id: 119,
          image: 'assets/img/clients/client19.jpg'
        },
        {
          id: 120,
          image: 'assets/img/clients/client20.jpg'
        },
        {
          id: 121,
          image: 'assets/img/clients/client21.jpg'
        },
        {
          id: 122,
          image: 'assets/img/clients/client22.jpg'
        }
      ]
    },
    {
      id: 2,
      category: 'Technical',
      details: [
        {
          id: 201,
          image: 'assets/img/clients/client23.jpg'
        },
        {
          id: 202,
          image: 'assets/img/clients/client24.jpg'
        },
        {
          id: 203,
          image: 'assets/img/clients/client25.jpg'
        },
        {
          id: 204,
          image: 'assets/img/clients/client26.jpg'
        },
        {
          id: 205,
          image: 'assets/img/clients/client27.jpg'
        },
        {
          id: 206,
          image: 'assets/img/clients/client28.jpg'
        },
        {
          id: 207,
          image: 'assets/img/clients/client29.jpg'
        },
        {
          id: 208,
          image: 'assets/img/clients/client30.jpg'
        },
        {
          id: 209,
          image: 'assets/img/clients/client31.jpg'
        },
        {
          id: 210,
          image: 'assets/img/clients/client32.jpg'
        },
        {
          id: 211,
          image: 'assets/img/clients/client33.jpg'
        },
        {
          id: 212,
          image: 'assets/img/clients/client34.jpg'
        },
        {
          id: 213,
          image: 'assets/img/clients/client35.jpg'
        },
        {
          id: 214,
          image: 'assets/img/clients/client36.jpg'
        },
        {
          id: 215,
          image: 'assets/img/clients/client37.jpg'
        },
        {
          id: 216,
          image: 'assets/img/clients/client38.jpg'
        },
        {
          id: 217,
          image: 'assets/img/clients/client39.jpg'
        },
        {
          id: 218,
          image: 'assets/img/clients/client40.jpg'
        }
      ]
    }
  ]
  currentTab: any = 1;
  currentIndDetail: any = [];

  constructor() { }

  ngOnInit() {
    this.currentIndDetail = this.clientListArr[0]?.details;
  }

  currentActiveCate(id, ind) {
    this.currentTab = id;
    this.currentIndDetail = this.clientListArr[ind]?.details;
  }

}
